import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import * as i4 from '@angular/common/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BehaviorSubject, throwError, filter, take, tap, catchError, of, finalize, EMPTY } from 'rxjs';
import { catchError as catchError$1, switchMap } from 'rxjs/operators';
import { jwtDecode } from 'jwt-decode';
import * as i1 from '@angular/router';
import * as i2 from 'ngx-permissions';
import { NgxPermissionsModule } from 'ngx-permissions';
import * as i3 from 'ngx-spinner';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DatePipe, DOCUMENT } from '@angular/common';
import { PhoneNumberUtil } from 'google-libphonenumber';
import * as i1$1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i2$1 from '@angular/platform-browser';

class NoCacheHeadersInterceptor {
    constructor() { }
    intercept(request, next) {
        const authReq = request.clone({
            setHeaders: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
            },
        });
        return next.handle(authReq);
    }
}
NoCacheHeadersInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NoCacheHeadersInterceptor, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
NoCacheHeadersInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NoCacheHeadersInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NoCacheHeadersInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

var Toast;
(function (Toast) {
    Toast["error"] = "toast-error";
    Toast["success"] = "toast-success";
    Toast["danger"] = "danger";
})(Toast || (Toast = {}));

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const environment = {
    production: true,
    // apiRoot: 'http://localhost:3001',
    // apiRoot: 'https://api-v2-dev.evento.sa',
    apiRoot: 'https://api.evento.sa',
    sportApiRoot: 'https://sport-api.evento.sa',
    authRoot: 'https://auth.evento.sa',
    apiRootAdmin: 'https://api.evento.sa/admin',
    defaultLanguage: 'ar',
    arTitle: 'Evento | ايفينتو ',
    MERCHANT_ID: '3000000011',
    MERCHANT_JS: 'https://ksa.gateway.mastercard.com/checkout/version/56/checkout.js',
    enTitle: 'Evento | ايفينتو',
    paymentRoot: 'https://pay.evento.sa/payment',
    workspaceKey: '072e53ac-2aa6-4e96-85fe-f5e9d7686d9c',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

const ACCESS_TOKEN = 'E_A_T';
const REFRESH_TOKEN = 'E_R_T';
const DEFAULT_LANGUAGE = 'DEFAULT_LANGUAGE';
const ROLES = 'ROLES';
const LIMIT = 12;
const AVATAR_BADGE = 'https://cdn-icons-png.flaticon.com/512/6596/6596121.png';
const REG_URL = '^(https?://)[0-9a-zA-Z]+.[-_0-9a-zA-Z]+.[0-9a-zA-Z]+$';
const fakeApi = `
{"info":{"firstName":"Ahmed","lastName":"Shaarawy","email":"ahmedshaarawy891@gmail.com","mobile":{"number":"+966535454646","internationalNumber":"+966 53 545 4646","nationalNumber":"053 545 4646","e164Number":"+966535454646","countryCode":"SA","dialCode":"+966"},"isValid":true},"items":[{"ticket":{"id":"e335cd4c-ae58-46e8-a586-a99906de504c","createdAt":"2022-10-24T18:39:31.669Z","updatedAt":"2022-11-16T18:57:41.207Z","deletedAt":null,"nameAr":"مجدولة","nameEn":"مجدولة","descriptionAr":"مجدولة","descriptionEn":"مجدولة","status":"ACTIVE","price":100,"quantity":10,"minimumPerOrder":1,"maximumPerOrder":0,"salesChannel":"ALL","salesStartDate":null,"salesEndDate":null,"isScheduled":true,"dateRequired":false,"audience":{"id":"8b642e72-cd5c-4b35-9d91-42d7b799b837","createdAt":"2022-04-15T19:20:03.595Z","updatedAt":"2022-04-15T19:20:03.595Z","deletedAt":null,"nameAr":"الجميع","nameEn":"الجميع","code":0},"ticketSchedules":[{"id":"a2b4c0cf-a291-4b5d-a02c-7d793150f8b3","createdAt":"2022-10-24T18:40:27.943Z","updatedAt":"2022-10-24T18:40:27.943Z","deletedAt":null,"price":null,"timeSchedules":[{"id":"fbe815a4-860d-4fcc-acac-3a3f0a2e75c9","createdAt":"2022-10-24T18:40:35.391Z","updatedAt":"2022-10-24T18:40:35.391Z","deletedAt":null,"time":{"id":"f4720857-6630-4d3a-b5c8-1f9c18353210","createdAt":"2022-10-24T18:40:35.367Z","updatedAt":"2022-10-24T18:40:35.367Z","deletedAt":null,"startAt":"16:00"}},{"id":"af43dd07-8e80-4bf5-af1f-3deadb752615","createdAt":"2022-10-24T18:40:44.056Z","updatedAt":"2022-10-24T18:40:44.056Z","deletedAt":null,"time":{"id":"6e5aee38-e9e7-4e4f-8701-f4c1752b54f6","createdAt":"2022-10-24T18:40:44.038Z","updatedAt":"2022-10-24T18:40:44.038Z","deletedAt":null,"startAt":"17:00"}}],"schedule":{"id":"e4899ee7-d456-49bc-800a-60fe1240ac5f","createdAt":"2022-10-24T17:52:39.031Z","updatedAt":"2022-10-24T17:52:39.031Z","deletedAt":null,"startAt":1666616400,"endAt":1666688400}},{"id":"f2171fac-ca80-422b-b5a4-b41e661567f5","createdAt":"2022-10-24T18:40:52.083Z","updatedAt":"2022-10-24T18:40:52.083Z","deletedAt":null,"price":null,"timeSchedules":[{"id":"5a9a8ecb-d188-4596-ae8d-7a58d18b209c","createdAt":"2022-10-24T18:40:58.766Z","updatedAt":"2022-10-24T18:40:58.766Z","deletedAt":null,"time":{"id":"23c20bff-77d0-4891-b3b4-e89fee4e9a39","createdAt":"2022-10-24T18:40:58.753Z","updatedAt":"2022-10-24T18:40:58.753Z","deletedAt":null,"startAt":"16:00"}}],"schedule":{"id":"61c5e4a3-0ced-47e7-9384-6ab2a260780b","createdAt":"2022-10-24T17:52:39.031Z","updatedAt":"2022-10-24T17:52:39.031Z","deletedAt":null,"startAt":1666702800,"endAt":1666774800}}],"times":[]},"quantity":2,"schedule":{"id":"e4899ee7-d456-49bc-800a-60fe1240ac5f","createdAt":"2022-10-24T17:52:39.031Z","updatedAt":"2022-10-24T17:52:39.031Z","deletedAt":null,"startAt":1666648800,"endAt":1666688400},"time":"6e5aee38-e9e7-4e4f-8701-f4c1752b54f6"},{"ticket":{"id":"38741b11-6d08-4779-b17e-455d3390168a","createdAt":"2022-10-25T18:36:43.160Z","updatedAt":"2022-11-16T20:11:28.028Z","deletedAt":null,"nameAr":"asdasd","nameEn":"asdasd","descriptionAr":"asdasdasd","descriptionEn":"asdasd","status":"ACTIVE","price":10,"quantity":1000,"minimumPerOrder":1,"maximumPerOrder":10,"salesChannel":"ALL","salesStartDate":null,"salesEndDate":null,"isScheduled":true,"dateRequired":false,"audience":{"id":"8b642e72-cd5c-4b35-9d91-42d7b799b837","createdAt":"2022-04-15T19:20:03.595Z","updatedAt":"2022-04-15T19:20:03.595Z","deletedAt":null,"nameAr":"الجميع","nameEn":"الجميع","code":0},"ticketSchedules":[{"id":"4f9ce0c1-2ade-4735-8538-8ba66265cad2","createdAt":"2022-10-25T18:45:02.627Z","updatedAt":"2022-10-25T18:45:02.627Z","deletedAt":null,"price":null,"timeSchedules":[],"schedule":{"id":"e4899ee7-d456-49bc-800a-60fe1240ac5f","createdAt":"2022-10-24T17:52:39.031Z","updatedAt":"2022-10-24T17:52:39.031Z","deletedAt":null,"startAt":1666616400,"endAt":1666688400}},{"id":"d87e751c-95b9-476d-8e0d-0a3d1af1d3e4","createdAt":"2022-10-25T18:44:08.069Z","updatedAt":"2022-10-25T18:44:08.069Z","deletedAt":null,"price":null,"timeSchedules":[],"schedule":{"id":"61c5e4a3-0ced-47e7-9384-6ab2a260780b","createdAt":"2022-10-24T17:52:39.031Z","updatedAt":"2022-10-24T17:52:39.031Z","deletedAt":null,"startAt":1666702800,"endAt":1666774800}},{"id":"015b35b7-6d00-414a-ae88-a09f5335e53e","createdAt":"2022-10-25T18:49:56.179Z","updatedAt":"2022-10-25T18:49:56.179Z","deletedAt":null,"price":null,"timeSchedules":[],"schedule":{"id":"39697df8-9ccb-4860-b526-0bf40ec4fc92","createdAt":"2022-10-24T17:52:39.031Z","updatedAt":"2022-10-24T17:52:39.031Z","deletedAt":null,"startAt":1666789200,"endAt":1666861200}},{"id":"1223ec4c-2776-43c4-a70c-7db18a32a9f7","createdAt":"2022-10-25T18:50:10.492Z","updatedAt":"2022-10-25T18:50:10.492Z","deletedAt":null,"price":null,"timeSchedules":[{"id":"87b76f2e-a86d-4802-bd4e-4151a0135c05","createdAt":"2022-10-25T18:50:10.504Z","updatedAt":"2022-10-25T18:50:10.504Z","deletedAt":null,"time":{"id":"42fe853e-6e9a-4d44-922a-21ab9473b5c5","createdAt":"2022-10-25T18:50:10.471Z","updatedAt":"2022-10-25T18:50:10.471Z","deletedAt":null,"startAt":"15:00"}}],"schedule":{"id":"c017a8ae-e603-453c-8bac-0bf9db0bc534","createdAt":"2022-10-24T17:52:39.031Z","updatedAt":"2022-10-24T17:52:39.031Z","deletedAt":null,"startAt":1666875600,"endAt":1666947600}},{"id":"ce1f30f7-161f-410c-b612-c1a17888cac5","createdAt":"2022-10-25T18:50:23.626Z","updatedAt":"2022-10-25T18:50:23.626Z","deletedAt":null,"price":null,"timeSchedules":[{"id":"65a1cf14-269d-4f46-9bbb-6dec4dbc0b93","createdAt":"2022-10-25T18:50:23.637Z","updatedAt":"2022-10-25T18:50:23.637Z","deletedAt":null,"time":{"id":"75b33e9f-630d-4225-be3f-cb602c6815ee","createdAt":"2022-10-25T18:50:23.610Z","updatedAt":"2022-10-25T18:50:23.610Z","deletedAt":null,"startAt":"17:00"}}],"schedule":{"id":"27155cba-80ed-4623-bc81-d4891cd566af","createdAt":"2022-10-24T17:52:39.031Z","updatedAt":"2022-10-24T17:52:39.031Z","deletedAt":null,"startAt":1666962000,"endAt":1667034000}},{"id":"edf0fdfd-cb92-4265-9460-923397d21f2a","createdAt":"2022-10-25T18:50:15.300Z","updatedAt":"2022-10-25T18:50:15.300Z","deletedAt":null,"price":null,"timeSchedules":[],"schedule":{"id":"4163f5f3-32b4-4ab4-81ea-d07e04d5e7b9","createdAt":"2022-10-24T17:52:39.031Z","updatedAt":"2022-10-24T17:52:39.031Z","deletedAt":null,"startAt":1667134800,"endAt":1667206800}}],"times":[]},"quantity":2,"schedule":{"id":"c017a8ae-e603-453c-8bac-0bf9db0bc534","createdAt":"2022-10-24T17:52:39.031Z","updatedAt":"2022-10-24T17:52:39.031Z","deletedAt":null,"startAt":1666908000,"endAt":1666947600},"time":"42fe853e-6e9a-4d44-922a-21ab9473b5c5"}],"customForm":{"values":[{"field":"0314cb1a-34da-4f3e-bb74-77a978640790","value":"1af7e0d7-bce5-401b-b2c0-5e567d4a2744"},{"field":"721b6c32-d6b4-45d5-810b-2b4b149d77d9","value":"2022-11-08T22:00:00.000Z"},{"field":"a9c56f51-d82b-4615-9c92-0d431c0d793b","value":"sdfsdf"},{"field":"9f7fc11c-e8e3-4d71-b43f-76d547ae8c6b","value":"2022-11-09T10:00:00.000Z"},{"field":"43f7c22d-9524-46da-bcb5-3dde005b4e02","value":10},{"field":"a55bc5b7-7d06-403a-a766-259f89aa4197","value":"37c22d33-2928-42b4-a7bc-002f6dd37f03,1d5c5222-7955-48b6-a07c-dc1237759814,d18dd278-2795-42d3-b9a1-44fd51e951f4"}],"isValid":true}}`;
const callToActionUrl = 'https://services.evento.sa/home';
const W_K = environment.workspaceKey;
const REGION = 'eu';
const googleAnalyticsId = 'GTM-KV88G9P';

const apiUrl = environment.apiRoot;
const authUrl = environment.authRoot;
const sportApiUrl = environment.sportApiRoot;
// Auth
const userApi = `${authUrl}/user`;
const loginApi = `${userApi}/login`;
const signupApi = `${userApi}/signup`;
const refreshTokenApi = `${authUrl}/auth/refresh-token`;
const logoutApi = `${authUrl}/auth/logout`;
const changePasswordApi = `${userApi}/profile/password`;
const resetPasswordApi = `${userApi}/reset-password`;
const activateApi = `${userApi}/activate`;
const otpSendActivateApi = `${activateApi}/send-otp`;
const otpVerifyActivateApi = `${activateApi}/verify-otp`;
const otpVerifyResetApi = `${resetPasswordApi}/verify-otp`;
const verifyEmailApi = `${activateApi}/email`;
const timeApi = `${authUrl}/auth/server-time`;
const usersApi = `${apiUrl}/users`;
const adminApi = `${apiUrl}/admin`;
const commercialRegistrationApi = `${apiUrl}/users/creators/commercial-registration`;
const userProfileApi = `${usersApi}/profile`;
const usersCreatorsApi = `${usersApi}/creators`;
const signupCreatorApi = `${usersApi}/creators/create`;
const creatorsApi = `${apiUrl}/creators`;
const clientsApi = `${apiUrl}/partners`;
const regionsApi = `${apiUrl}/regions`;
const citiesApi = `${regionsApi}/cities`;
const audienceApi = `${apiUrl}/common/audience`;
const eventTypesApi = `${apiUrl}/common/eventType`;
const contactUsApi = `${apiUrl}/contact-us/create`;
const eventsApi = `${apiUrl}/events`;
const eventsFeeApi = `${apiUrl}/eventsFee`;
const settingsApi = `${creatorsApi}/events`;
const eventsStatisticsApi = `${apiUrl}/events/statistic/dashboard`;
const eventsDashboardApi = `${eventsApi}/dashboard`;
const dashboardApi = `${apiUrl}/dashboard`;
const publicEventApi = `${apiUrl}/public/event`;
const publicEventsApi = `${apiUrl}/public/events`;
const banners = `${apiUrl}/banners`;
const ticketsApi = `${apiUrl}/events/tickets`;
const publicPaymentsApi = `${apiUrl}/public/payments`;
const validateCouponApi = `${apiUrl}/public/payments/promo-code/validate`;
const attachmentsApi = `${apiUrl}/attachments`;
const paymentsApi = `${apiUrl}/payments`;
const statisticsRoleApi = `${userApi}/statistics/role`;
const statisticsStatusApi = `${userApi}/statistics/status`;
const usersManageApi = `${usersApi}/administration`;
const exportSoldTicketsAdmin = `${adminApi}/tickets/download-excel`;
const resendEmailActivationLink = `${adminApi}/users`;
const bookCustomTicketForAdmin = `${adminApi}/payments/invoice`;
const bookCustomTicketForEventUser = `${apiUrl}/sales-persons/payments/invoice`;
const getAllTickets = `${adminApi}/payments/tickets/table`;
const exportAllTickets = `${adminApi}/payments/tickets/table/download`;
const ticketsStatastics = `${adminApi}/payments/tickets/statistics/status`;
const resendTickets = `${adminApi}/payments/invoices`;
const refundInvoice = `${adminApi}/payments/invoice`;
const addClient = `${adminApi}/partners`;
const exportSoldTicketsCreator = `${creatorsApi}/tickets/download-excel`;
const viewInvoiceDetailsCreator = `${creatorsApi}/invoices`;
const changeEventStatus = `${eventsApi}/dashboard`;
const relatedEventsUser = `${eventsApi}/users/linked-events`;
const soldTicketsForSalesPerson = `${paymentsApi}/events`;
const ticketsTypesForSalesPerson = `${eventsApi}/users/event`;
const invitationApi = `${eventsApi}/users/invite`;
const checkInTicketApi = `${apiUrl}/scanners/events/orders`;
const dailyInventoryReport = `${apiUrl}/scanners/events/daily-inventory`;
const getPermission = `${apiUrl}/resources`;
const getUserPermission = `${apiUrl}/permission/user`;
const updateUserPermission = `${apiUrl}/permission/user`;
const terminalsApi = `${apiUrl}/terminal`;
const invitationsApi = `${apiUrl}/invitations`;
const weaponsApi = `${apiUrl}/weapons`;
const accessWeaponsApi = `${apiUrl}/access-weapons`;
const accessWeaponsManagementApi = `${apiUrl}/access-weapons-management`;
const tagsApi = `${apiUrl}/tags`;
const buyerMailingTemplate = `${apiUrl}/buyer-mailing-template`;
const badgeApi = `${apiUrl}/badge-template`;
// Sport apis
const matchesApi = `${sportApiUrl}/matches`;
const championsApi = `${sportApiUrl}/champions`;
const teamsApi = `${sportApiUrl}/teams`;
const stadiumsApi = `${sportApiUrl}/stadiums`;
const commonCitiesApi = `${sportApiUrl}/common/cities`;
const sportsMyTicketsApi = `${sportApiUrl}/orders/my-tickets`;
const transferTicketApi = `${sportApiUrl}/transfer-order`;
const sponsersApi = `${sportApiUrl}/sponsor`;
const sportticketsApi = `${sportApiUrl}/tickets`;
const sportInvoicesApi = `${sportApiUrl}/invoices`;
const sportEarlySalesApi = `${sportApiUrl}/early-sales`;

class AuthService {
    constructor(router, permissionsService, spinner, dataService) {
        this.router = router;
        this.permissionsService = permissionsService;
        this.spinner = spinner;
        this.dataService = dataService;
        this.user = new BehaviorSubject(null);
        this.user$ = this.user.asObservable();
        this.isRefreshing = false;
        this.refreshTokenSubject = new BehaviorSubject(null);
        this.isLoggingOut = false;
        console.log('AuthService initialized');
    }
    setUser(user) {
        this.user.next(user);
    }
    fetchUser() {
        const token = localStorage.getItem(ACCESS_TOKEN)
            ? JSON.parse(localStorage.getItem(ACCESS_TOKEN))
            : null;
        if (!token) {
            this.clearLocalStorage();
            return;
        }
        try {
            const decoded = jwtDecode(token);
            if (!decoded.user) {
                throw new Error('Invalid token structure');
            }
            // Ensure we're working with an array
            const userRoles = decoded.user?.roles || [];
            const roles = Array.isArray(userRoles)
                ? userRoles.map((item) => item?.key).filter(Boolean)
                : [];
            this.permissionsService.loadPermissions(roles);
            localStorage.setItem(ROLES, JSON.stringify(roles));
            this.setUser(decoded.user);
        }
        catch (error) {
            console.error('Token decoding failed:', error);
            this.clearLocalStorage();
        }
    }
    isAuthenticated() {
        const token = localStorage.getItem(ACCESS_TOKEN)
            ? JSON.parse(localStorage.getItem(ACCESS_TOKEN))
            : null;
        return !!token;
    }
    signIn(mobile, password) {
        const body = {
            mobile: mobile.number,
            mobileRegionCode: mobile.countryCode,
            password: password,
        };
        return this.dataService.post(`${loginApi}`, body);
    }
    refreshToken() {
        const refreshToken = localStorage.getItem(REFRESH_TOKEN);
        if (!refreshToken) {
            console.error('No refresh token available');
            return throwError(() => new Error('No refresh token available'));
        }
        // If refresh is already in progress, return the subject as an observable
        if (this.isRefreshing) {
            return this.refreshTokenSubject.pipe(filter((token) => token !== null), // Type guard
            take(1) // Complete after the first emission
            );
        }
        // Start the refresh process
        this.isRefreshing = true;
        this.refreshTokenSubject.next(null);
        return this.dataService.post(`${refreshTokenApi}`, {}).pipe(tap((response) => {
            if (!response?.access_token) {
                throw new Error('Invalid token response');
            }
            localStorage.setItem(ACCESS_TOKEN, JSON.stringify(response.access_token));
            if (response.refresh_token) {
                localStorage.setItem(REFRESH_TOKEN, JSON.stringify(response.refresh_token));
            }
            this.refreshTokenSubject.next(response.access_token);
            this.isRefreshing = false;
        }), catchError((error) => {
            console.error('Refresh token failed:', error);
            this.isRefreshing = false;
            this.refreshTokenSubject.next(null);
            this.logout().subscribe();
            return throwError(() => error);
        }));
    }
    logout() {
        if (this.isLoggingOut) {
            return of(null);
        }
        this.isLoggingOut = true;
        this.spinner.show();
        const logout$ = localStorage.getItem(ACCESS_TOKEN)
            ? this.dataService.post(`${logoutApi}`, {}).pipe(catchError((error) => {
                console.error('Logout API error:', error);
                return of(null);
            }))
            : of(null);
        return logout$.pipe(finalize(() => {
            this.clearLocalStorage();
            this.spinner.hide();
            this.isLoggingOut = false;
        }));
    }
    clearLocalStorage() {
        localStorage.removeItem(ACCESS_TOKEN);
        localStorage.removeItem(REFRESH_TOKEN);
        localStorage.removeItem(ROLES);
        this.setUser(null);
        this.permissionsService.flushPermissions();
        // Only navigate if not already on auth page
        if (window.location.origin.includes('falak') ||
            window.location.origin.includes('thestage')) {
        }
        else {
            if (!this.router.url.includes('/auth')) {
                this.router.navigateByUrl('/auth');
            }
        }
    }
}
AuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthService, deps: [{ token: i1.Router }, { token: i2.NgxPermissionsService }, { token: i3.NgxSpinnerService }, { token: i4.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
AuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.Router }, { type: i2.NgxPermissionsService }, { type: i3.NgxSpinnerService }, { type: i4.HttpClient }]; } });

class ToastService {
    constructor() {
        this.toasts = [];
    }
    async show(title, textOrTpl, options = {}) {
        this.toasts.push({ title: title, textOrTpl: textOrTpl, ...options });
    }
    remove(toast) {
        this.toasts = this.toasts.filter((t) => t !== toast);
    }
}
ToastService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToastService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ToastService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToastService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ToastService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class ErrorInterceptor {
    constructor(authService, spinner, toast, router) {
        this.authService = authService;
        this.spinner = spinner;
        this.toast = toast;
        this.router = router;
    }
    intercept(req, next) {
        return next.handle(req).pipe(catchError$1((err) => {
            this.spinner.hide();
            // Log the full error for debugging
            console.error('HTTP Error:', {
                url: req.url,
                status: err.status,
                error: err.error,
                message: err.message,
            });
            // Handle error message extraction
            const errorMessage = this.extractErrorMessage(err);
            // Handle specific error statuses
            switch (err.status) {
                case 400:
                case 404:
                case 503:
                case 0:
                    if (errorMessage) {
                        this.showToast('Error', errorMessage, Toast.error);
                    }
                    break;
                case 401:
                case 403:
                    this.handleAuthError(err);
                    return EMPTY; // Stop error propagation after handling
                case 500:
                    this.showToast('Error', 'An error occurred', Toast.error);
                    break;
            }
            // For all other errors, throw with proper error object
            return throwError(() => err);
        }));
    }
    extractErrorMessage(err) {
        console.log(err);
        if (!err.error?.message)
            return err.message || 'Unknown error occurred';
        if (Array.isArray(err.error.message)) {
            const firstError = err.error.message[0];
            return (firstError.message ||
                firstError.constraints?.[Object.keys(firstError.constraints)[0]] ||
                'Validation error');
        }
        return err.error.message;
    }
    showToast(title, message, toastType) {
        try {
            this.toast.show(title, message, {
                classname: toastType,
                delay: 5000,
            });
        }
        catch (error) {
            console.error('Error showing toast:', error);
        }
    }
    handleAuthError(err) {
        try {
            if (err.url?.includes('logout') || err.url?.includes('refresh-token')) {
                console.log('Authentication failed during logout or token refresh');
                this.authService.clearLocalStorage();
                window.location.reload();
            }
            else if (err.url?.includes('login')) {
                const errorMessage = this.extractErrorMessage(err);
                this.showToast('Error', errorMessage, Toast.error);
            }
            else {
                console.log('auth error');
                this.authService.logout().subscribe({
                    complete: () => window.location.reload(),
                    error: (error) => {
                        console.error('Error during logout:', error);
                        window.location.reload();
                    },
                });
            }
        }
        catch (error) {
            console.error('Error handling auth error:', error);
            window.location.reload();
        }
    }
}
ErrorInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ErrorInterceptor, deps: [{ token: AuthService }, { token: i3.NgxSpinnerService }, { token: ToastService }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
ErrorInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ErrorInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ErrorInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: AuthService }, { type: i3.NgxSpinnerService }, { type: ToastService }, { type: i1.Router }]; } });

class TokenInterceptor {
    constructor(authService) {
        this.authService = authService;
    }
    intercept(request, next) {
        // Skip interception for specific requests
        if (this.shouldSkipInterceptor(request)) {
            return next.handle(request);
        }
        // Get current language
        const currentLang = localStorage.getItem(DEFAULT_LANGUAGE) || 'ar';
        // Prepare headers
        const headers = {
            'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
            Pragma: 'no-cache',
            'Access-Language': currentLang,
            'Accept-Language': currentLang,
        };
        // Handle refresh token request differently
        if (request.url.includes('/auth/refresh-token')) {
            const refreshToken = JSON.parse(localStorage.getItem(REFRESH_TOKEN));
            if (refreshToken) {
                headers['Authorization'] = `Bearer ${refreshToken}`;
            }
            return next.handle(request.clone({ setHeaders: headers }));
        }
        const token = localStorage.getItem(ACCESS_TOKEN)
            ? JSON.parse(localStorage.getItem(ACCESS_TOKEN))
            : null;
        // If no token or token not expired, proceed normally
        if (!token || !this.isTokenExpired(token)) {
            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            }
            return next.handle(request.clone({ setHeaders: headers }));
        }
        // Token is expired, try to refresh
        return this.authService.refreshToken().pipe(switchMap(() => {
            // After successful refresh, get the new token
            const newToken = JSON.parse(localStorage.getItem(ACCESS_TOKEN));
            if (newToken) {
                headers['Authorization'] = `Bearer ${newToken}`;
            }
            return next.handle(request.clone({ setHeaders: headers }));
        }), catchError$1((error) => {
            // Let the error interceptor handle the error
            return throwError(() => error);
        }));
    }
    shouldSkipInterceptor(request) {
        // Add any URLs that shouldn't be intercepted (e.g., login, public APIs)
        return [
            '/auth/login',
            '/auth/register',
            // Add other public endpoints here
        ].some((path) => request.url.includes(path));
    }
    isTokenExpired(token) {
        const payload = jwtDecode(token);
        const now = Math.floor(Date.now() / 1000); // Current time in seconds
        let diff = localStorage.getItem('serverDiff')
            ? JSON.parse(localStorage.getItem('serverDiff'))
            : 0;
        return payload.exp < now + diff;
    }
}
TokenInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TokenInterceptor, deps: [{ token: AuthService }], target: i0.ɵɵFactoryTarget.Injectable });
TokenInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TokenInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TokenInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: AuthService }]; } });

const pad = (i) => (i < 10 ? `0${i}` : `${i}`);
class HelpersService {
    constructor(translate) {
        this.translate = translate;
    }
    setItemToLocalStorage(name, value) {
        localStorage.setItem(name, JSON.stringify(value));
    }
    getItemFromLocalStorage(name) {
        return JSON.parse(localStorage.getItem(name));
    }
    removeItemFromLocalStorage(name) {
        localStorage.removeItem(name);
    }
    checkItemFromLocalStorage(name) {
        return !!localStorage.getItem(name);
    }
    fillField(form, field, value) {
        form.controls[field].patchValue(value);
    }
    trackBy(item) {
        return item.id;
    }
    getDate(date) {
        return new Date(date.year + '/' + date.month + '/' + date.day);
    }
    getStringDate(date) {
        return `${pad(date.day)}/${pad(date.month)}/${date?.year}`;
    }
    getISOFormatFromStringDate(value) {
        let date = value?.split(' ')[0];
        const time = value?.split(' ')[1];
        date = date?.split('/').reverse().join('/');
        return new Date(`${date} ${time}`)?.toISOString();
    }
    appendTimeToDate(date, time) {
        return new Date(`${date} ${time}`);
    }
    formatDateForCustomValidators(date) {
        const fieldFormat = new DatePipe('en').transform(date, 'yyyy-MM-dd');
        return fieldFormat;
    }
    getUniqueArray(oldArr, newArr) {
        if (!oldArr.length) {
            oldArr.push(...newArr);
            return oldArr;
        }
        newArr.forEach((item) => {
            if (!oldArr.find((x) => x.id === item.id)) {
                oldArr.push(item);
            }
        });
        return oldArr;
    }
    getElementTranslatedName(el) {
        const currLang = this.translate.currentLang;
        return currLang === 'ar'
            ? el?.nameAr
            : el?.nameEn
                ? el?.nameEn
                : el?.nameAr;
    }
    getElementTranslatedDescBase(el) {
        const currLang = this.translate.currentLang;
        return currLang === 'ar'
            ? el.descriptionAr
            : el.descriptionEn
                ? el.descriptionEn
                : el.descriptionAr;
    }
    getElementTranslatedDescRest(el) {
        const currLang = this.translate.currentLang;
        return currLang === 'ar'
            ? el.descriptionAr?.substr(50, el.descriptionAr.length)
            : el.descriptionEn?.substr(50, el.descriptionEn.length);
    }
    getElementTranslatedAddress(el) {
        const currLang = this.translate.currentLang;
        let address = '';
        if (currLang === 'ar') {
            if (el.addressAr) {
                address = el.addressAr;
            }
            else {
                address = el.addressEn;
            }
        }
        else {
            if (el.addressEn) {
                address = el.addressEn;
            }
            else {
                address = el.addressAr;
            }
        }
        return address;
        // return currLang === 'ar' ? el.addressAr : el.addressEn;
    }
    getDatesInRange(startDate, endDate) {
        const date = new Date(startDate.getTime());
        const dates = [];
        while (date <= endDate) {
            dates.push(new Date(date));
            date.setDate(date.getDate() + 1);
        }
        return dates;
    }
    divideBy100(number) {
        return number;
        // return (number).toFixed(2);
    }
    get isUserAdmin() {
        return localStorage.getItem(ROLES)?.includes('superadmin');
    }
    get isUserEventCreator() {
        return localStorage.getItem(ROLES)?.includes('creator');
    }
    get isUserEventUser() {
        return localStorage.getItem(ROLES)?.includes('event-user');
    }
    englishFieldValidationMinDesc(control) {
        const value = (control.value || '').replace(/(<([^>]+)>)/gi, '').trim();
        const isValid = value ? value.length > 10 : true;
        return isValid ? null : { minlength: true };
    }
    englishFieldValidationMaxDesc(control) {
        const value = (control.value || '').replace(/(<([^>]+)>)/gi, '').trim();
        const isValid = value ? value.length < 100 : true;
        return isValid ? null : { maxlength: true };
    }
    removeHTMLTags(html) {
        var div = document.createElement('div');
        div.innerHTML = html;
        return div.innerText; // Hello, World
    }
    englishFieldValidationMinName(control) {
        const value = (control.value || '').replace(/(<([^>]+)>)/gi, '').trim();
        const isValid = value ? value.length > 3 : true;
        return isValid ? null : { minlength: true };
    }
    englishFieldValidationMaxName(control) {
        const value = (control.value || '').replace(/(<([^>]+)>)/gi, '').trim();
        const isValid = value ? value.length < 40 : true;
        return isValid ? null : { maxlength: true };
    }
    arabicPatternValidator(control) {
        const arabicLettersPattern = '^[\u0621-\u064A\u0660-\u06690-9_ ]+$';
        const value = (control.value || '').replace(/(<([^>]+)>)/gi, '').trim();
        const isValid = value.match(arabicLettersPattern);
        return isValid ? null : { pattern: true };
    }
    arabicAndEnglishPatternValidator(control) {
        const arabicLettersPattern = '^[\u0621-\u064A\u0660-\u0669]+$';
        const englishLettersPattern = '^[a-zA-Z]+$';
        const isValid = control.value.match(arabicLettersPattern) ||
            control.value.match(englishLettersPattern);
        return isValid ? null : { pattern: true };
    }
    arabicAndEnglishPatternWithSpaceValidator(control) {
        const arabicLettersPattern = '[\u0621-\u064A\u0660-\u0669]';
        const englishLettersPattern = '[a-zA-Z]';
        const allowedCharactersPattern = `^(${arabicLettersPattern}|${englishLettersPattern}|\\s)+$`;
        const containsValidCharactersPattern = new RegExp(allowedCharactersPattern);
        const containsNonSpaceCharacters = new RegExp(`${arabicLettersPattern}|${englishLettersPattern}`);
        if (!control.value || typeof control.value !== 'string') {
            return { pattern: true };
        }
        const isValid = containsValidCharactersPattern.test(control.value) &&
            containsNonSpaceCharacters.test(control.value);
        return isValid ? null : { pattern: true };
    }
    arabicAndSpecialCharsValidator(control) {
        const arabicAndSpecialCharsPattern = /^[\u0621-\u064A\u0660-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DE-\u06FF\u0750-\u077F\u08A0-\u08BD\uFB50-\uFDFF\uFE70-\uFEFF\s,\/.,،\-()؟\[\]&*^%$#@!"':;]*$/;
        const value = (control.value || '').replace(/(<([^>]+)>)/gi, '').trim();
        return arabicAndSpecialCharsPattern.test(value) ? null : { pattern: true };
    }
    englishPatternValidator(control) {
        const englishLettersPattern = '^[a-zA-Z0-9_ ]+$';
        const value = (control.value || '').replace(/(<([^>]+)>)/gi, '').trim();
        const isValid = value ? value.match(englishLettersPattern) : true;
        return isValid ? null : { pattern: true };
    }
    noOnlyWhitespaceValidator() {
        return (control) => {
            const isWhitespace = (control.value || '').trim().length === 0 && control.value.length !== 0;
            const isValid = !isWhitespace;
            return isValid ? null : { onlyWhitespace: true };
        };
    }
    atLeastOneRequiredValidator() {
        return (control) => {
            const value = control.value;
            if (value.length === 0) {
                return { atLeastOneRequired: true };
            }
            return null;
        };
    }
    getCategoryColor(category) {
        if (category.nameAr == 'تعليمي') {
            return '#E47D87';
        }
        else if (category.nameAr == 'فنون و ثقافة') {
            return '#067A91';
        }
        else if (category.nameAr == 'رياضة') {
            return '#077D55';
        }
        else if (category.nameAr == 'تراثي') {
            return '#E28300';
        }
        else if (category.nameAr == 'مجانية') {
            return '#7B61FF';
        }
        else if (category.nameAr == 'معرض') {
            return '#1E1E1E';
        }
        else if (category.nameAr == 'كرنفال') {
            return '#8F49DE';
        }
        else if (category.nameAr == 'عرض') {
            return '#8ED8AC';
        }
        else if (category.nameAr == 'مهرجان') {
            return '#E4B400';
        }
        else if (category.nameAr == 'ازياء') {
            return '#D770D9';
        }
        else if (category.nameAr == 'ألعاب') {
            return '#EA4040';
        }
        else if (category.nameAr == 'أونلاين') {
            return '#A1A5A3';
        }
        else if (category.nameAr == 'موسيقى') {
            return '#074479';
        }
        else {
            return '#074479';
        }
    }
    extractRegionCode(mobileNumber) {
        try {
            const phoneUtil = PhoneNumberUtil.getInstance();
            const number = phoneUtil.parse(mobileNumber);
            const countryCode = number.getCountryCode();
            return `+${countryCode}`;
        }
        catch (error) {
            return null;
        }
    }
    extractCountryCode(mobileNumber) {
        try {
            const phoneUtil = PhoneNumberUtil.getInstance();
            const number = phoneUtil.parse(mobileNumber);
            const countryCode = phoneUtil.getRegionCodeForNumber(number);
            return countryCode;
        }
        catch (error) {
            console.error('Error parsing phone number:', error);
            return null;
        }
    }
    getUserFromToken() {
        const token = this.getItemFromLocalStorage(ACCESS_TOKEN);
        if (token) {
            const user = jwtDecode(token);
            return user.user;
        }
        else {
            return null;
        }
    }
    isTokenExpired(token) {
        const payload = jwtDecode(token);
        const now = Math.floor(Date.now() / 1000); // Current time in seconds
        let diff = localStorage.getItem('serverDiff')
            ? JSON.parse(localStorage.getItem('serverDiff'))
            : 0;
        return payload.exp < now + diff;
    }
    returnMobileArabic(mobile) {
        return mobile.substr(1, mobile.length - 1) + mobile[0];
    }
    convertToAMPM(time) {
        let [hours, minutes, seconds] = time?.split(':').map(Number);
        let ampm = hours >= 12
            ? this.translate.instant('PM')
            : this.translate.instant('AM');
        hours = hours % 12 || 12; // Convert 0 to 12 for AM/PM format
        return `${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
    }
    parseSeatCode(seatCode) {
        const regex = /^([A-Z0-9]+)-([A-Z]+)-(\d+)$/;
        const seat = seatCode.match(regex);
        if (seat) {
            return {
                Section: seat[1],
                Row: seat[2],
                Seat: seat[3],
            };
        }
        return null;
    }
    noSpecialCharsAndTrim(control) {
        if (typeof control.value !== 'string')
            return null;
        const value = control.value;
        const nonSpaceValue = value.replace(/\s/g, '');
        if (nonSpaceValue.length < 2) {
            return { minlength: true };
        }
        const pattern = /^[a-zA-Z\u0621-\u064A\s]+$/;
        return pattern.test(value) ? null : { invalidCharacters: true };
    }
}
HelpersService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HelpersService, deps: [{ token: i1$1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
HelpersService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HelpersService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HelpersService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }]; } });

class LanguageService {
    constructor(translateService, titleService, document) {
        this.translateService = translateService;
        this.titleService = titleService;
        this.document = document;
        this.SUPPORTED_LANGUAGES = ['en', 'ar'];
        this.initialized = false;
    }
    loadDefaultLangsAndStyles() {
        if (this.initialized) {
            return;
        }
        try {
            // Set available languages
            console.log('this.SUPPORTED_LANGUAGES', this.SUPPORTED_LANGUAGES);
            this.translateService.addLangs(this.SUPPORTED_LANGUAGES);
            // Get stored or default language
            const storedLang = localStorage.getItem(DEFAULT_LANGUAGE);
            const defaultLang = storedLang && this.SUPPORTED_LANGUAGES.includes(storedLang)
                ? storedLang
                : 'ar';
            // Initialize translations
            this.translateService.setDefaultLang(defaultLang);
            this.translateService.use(defaultLang);
            // Set styles and direction
            this.setStylesDirections(defaultLang);
            this.initialized = true;
        }
        catch (error) {
            console.error('Error in loadDefaultLangsAndStyles:', error);
            // Fallback initialization
            this.translateService.setDefaultLang('ar');
            this.translateService.use('ar');
            this.setStylesDirections('ar');
            this.initialized = true;
        }
    }
    getCurrnetLang() {
        try {
            const currentLang = this.translateService.currentLang;
            if (!currentLang) {
                console.warn('No current language set, defaulting to ar');
                return 'ar';
            }
            return currentLang;
        }
        catch (error) {
            console.error('Error in getCurrnetLang:', error);
            return 'ar';
        }
    }
    setStylesDirections(lang) {
        try {
            if (!lang || typeof lang !== 'string') {
                console.warn('Invalid language provided to setStylesDirections:', lang);
                lang = 'ar';
            }
            const htmlTag = this.document.getElementsByTagName('html')[0];
            if (!htmlTag) {
                throw new Error('HTML tag not found');
            }
            const isArabic = lang === 'ar';
            // Set direction
            this.document.body.setAttribute('dir', isArabic ? 'rtl' : 'ltr');
            // Update classes
            htmlTag.classList.remove(isArabic ? 'ltr' : 'rtl');
            htmlTag.classList.add(isArabic ? 'rtl' : 'ltr');
            // Set language
            htmlTag.setAttribute('lang', lang);
            // Load appropriate style
            this.loadStyle(isArabic ? 'rtl-style.css' : 'ltr-style.css');
            // Set title
            this.titleService.setTitle(isArabic ? environment.arTitle : environment.enTitle);
            // Ensure translation service is using the correct language
            this.translateService.use(lang);
        }
        catch (error) {
            console.error('Error in setStylesDirections:', error);
            // Fallback to Arabic
            this.setStylesDirections('ar');
        }
    }
    loadStyle(styleName) {
        try {
            if (!styleName || typeof styleName !== 'string') {
                console.warn('Invalid style name provided to loadStyle:', styleName);
                return;
            }
            const head = this.document.getElementsByTagName('head')[0];
            if (!head) {
                throw new Error('Head tag not found');
            }
            let styleLink = this.document.getElementById('client-theme');
            if (!styleLink) {
                styleLink = this.document.createElement('link');
                styleLink.id = 'client-theme';
                styleLink.rel = 'stylesheet';
                head.appendChild(styleLink);
            }
            styleLink.href = styleName;
        }
        catch (error) {
            console.error('Error in loadStyle:', error);
        }
    }
    switchLanguages() {
        try {
            const currentLang = this.getCurrnetLang();
            if (!currentLang || !this.SUPPORTED_LANGUAGES.includes(currentLang)) {
                console.warn('Invalid current language:', currentLang);
                return;
            }
            const newLang = currentLang === 'en' ? 'ar' : 'en';
            localStorage.setItem(DEFAULT_LANGUAGE, newLang);
            this.translateService.use(newLang);
            this.setStylesDirections(newLang);
        }
        catch (error) {
            console.error('Error switching languages:', error);
        }
    }
}
LanguageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LanguageService, deps: [{ token: i1$1.TranslateService }, { token: i2$1.Title }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
LanguageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LanguageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LanguageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }, { type: i2$1.Title }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

class HttpBaseService {
    constructor(http) {
        this.http = http;
    }
    getTags() {
        throw new Error('Method not implemented.');
    }
    post(apiUrl, body, options) {
        return this.http.post(apiUrl, body, options);
    }
    patch(apiUrl, body, options) {
        return this.http.patch(apiUrl, body, options);
    }
    get(apiUrl, options) {
        return this.http.get(apiUrl, options);
    }
    delete(apiUrl, options) {
        return this.http.delete(apiUrl, options);
    }
    put(apiUrl, body, options) {
        return this.http.put(apiUrl, body, options);
    }
}
HttpBaseService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HttpBaseService, deps: [{ token: i4.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
HttpBaseService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HttpBaseService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HttpBaseService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i4.HttpClient }]; } });

class ScriptInjectorService {
    constructor() { }
    injectGtm() {
        this.injectHeadScript();
        this.injectNoscriptFallback();
    }
    injectHeadScript() {
        const script = document.createElement('script');
        script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${googleAnalyticsId}');
    `;
        document.head.appendChild(script);
    }
    injectNoscriptFallback() {
        const noscript = document.createElement('noscript');
        noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${googleAnalyticsId}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
        document.body.insertBefore(noscript, document.body.firstChild);
    }
}
ScriptInjectorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ScriptInjectorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ScriptInjectorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ScriptInjectorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ScriptInjectorService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return []; } });

class SharedHttpModule {
    static forRoot() {
        return {
            ngModule: SharedHttpModule,
            providers: [],
        };
    }
}
SharedHttpModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SharedHttpModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SharedHttpModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: SharedHttpModule, imports: [NgxSpinnerModule,
        HttpClientModule, i2.NgxPermissionsModule, TranslateModule], exports: [HttpClientModule,
        NgxSpinnerModule,
        TranslateModule,
        NgxPermissionsModule] });
SharedHttpModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SharedHttpModule, providers: [
        ToastService,
        HttpBaseService,
        HelpersService,
        AuthService,
        ScriptInjectorService,
        LanguageService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: NoCacheHeadersInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },
    ], imports: [NgxSpinnerModule,
        HttpClientModule,
        NgxPermissionsModule.forRoot(),
        TranslateModule, HttpClientModule,
        NgxSpinnerModule,
        TranslateModule,
        NgxPermissionsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SharedHttpModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        NgxSpinnerModule,
                        HttpClientModule,
                        NgxPermissionsModule.forRoot(),
                        TranslateModule,
                    ],
                    providers: [
                        ToastService,
                        HttpBaseService,
                        HelpersService,
                        AuthService,
                        ScriptInjectorService,
                        LanguageService,
                        {
                            provide: HTTP_INTERCEPTORS,
                            useClass: TokenInterceptor,
                            multi: true,
                        },
                        {
                            provide: HTTP_INTERCEPTORS,
                            useClass: NoCacheHeadersInterceptor,
                            multi: true,
                        },
                        {
                            provide: HTTP_INTERCEPTORS,
                            useClass: ErrorInterceptor,
                            multi: true,
                        },
                    ],
                    exports: [
                        HttpClientModule,
                        NgxSpinnerModule,
                        TranslateModule,
                        NgxPermissionsModule,
                    ],
                }]
        }] });

/*
 * Public API Surface of shared-http
 */
//main module

/**
 * Generated bundle index. Do not edit.
 */

export { ACCESS_TOKEN, AVATAR_BADGE, AuthService, DEFAULT_LANGUAGE, HelpersService, HttpBaseService, LIMIT, LanguageService, REFRESH_TOKEN, REGION, REG_URL, ROLES, ScriptInjectorService, SharedHttpModule, ToastService, W_K, accessWeaponsApi, accessWeaponsManagementApi, activateApi, addClient, adminApi, attachmentsApi, audienceApi, badgeApi, banners, bookCustomTicketForAdmin, bookCustomTicketForEventUser, buyerMailingTemplate, callToActionUrl, championsApi, changeEventStatus, changePasswordApi, checkInTicketApi, citiesApi, clientsApi, commercialRegistrationApi, commonCitiesApi, contactUsApi, creatorsApi, dailyInventoryReport, dashboardApi, eventTypesApi, eventsApi, eventsDashboardApi, eventsFeeApi, eventsStatisticsApi, exportAllTickets, exportSoldTicketsAdmin, exportSoldTicketsCreator, fakeApi, getAllTickets, getPermission, getUserPermission, googleAnalyticsId, invitationApi, invitationsApi, loginApi, logoutApi, matchesApi, otpSendActivateApi, otpVerifyActivateApi, otpVerifyResetApi, paymentsApi, publicEventApi, publicEventsApi, publicPaymentsApi, refreshTokenApi, refundInvoice, regionsApi, relatedEventsUser, resendEmailActivationLink, resendTickets, resetPasswordApi, settingsApi, signupApi, signupCreatorApi, soldTicketsForSalesPerson, sponsersApi, sportEarlySalesApi, sportInvoicesApi, sportsMyTicketsApi, sportticketsApi, stadiumsApi, statisticsRoleApi, statisticsStatusApi, tagsApi, teamsApi, terminalsApi, ticketsApi, ticketsStatastics, ticketsTypesForSalesPerson, timeApi, transferTicketApi, updateUserPermission, userApi, userProfileApi, usersApi, usersCreatorsApi, usersManageApi, validateCouponApi, verifyEmailApi, viewInvoiceDetailsCreator, weaponsApi };
